import React from "react";
import PropTypes from "prop-types";
import StaffList from "../../components/StaffList";
import { Row, Col } from "reactstrap";
import WithFetchStaffs from "../WithFetchStaffs/index";
import { Link } from "react-router-dom";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faPlus, faEdit } from "@fortawesome/fontawesome-free-solid";
import Checkbox from "../../components/CustomCheckbox";
import { findIndex, omit } from "lodash";
import { compose, setDisplayName, withHandlers } from "recompose";

const propTypes = {
  staffs: PropTypes.array
};

 const Staffs = compose(
  setDisplayName("Staffs"),
  withHandlers({
    onCheckNotify: ({ updateStaff, currentDealer, setStaffs, staffs }) => ({
      staff,
      type
    }) => ev => {
      updateStaff({
        dealer_id: currentDealer.id,
        staff_id: staff.id,
        data: Object.assign(
          {},
          omit(staff, ["user"]),
          { [type]: !staff[type] },
          { user_attributes: staff.user }
        )
      }).then(resolvedStaff => {
        let nextStaffs = Object.create(staffs);
        let index = findIndex(nextStaffs, { id: resolvedStaff.id });
        if (index !== -1) {
          nextStaffs.splice(index, 1, resolvedStaff);
          setStaffs(nextStaffs);
        }
      });
    },
    oncheckViewInactive: ({dispatch, activeStaffs})=> ev => {
     dispatch(activeStaffs)
    }
  })
)(props => {
  const { staffs, match, onCheckNotify, active,oncheckViewInactive} = props;
  return (
    <div className="card">
      <div className="content">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <h3>
              <b>Staff</b>
            </h3>
             {active &&(<div className="selectable btn btn-primary" onClick={()=>{oncheckViewInactive()}}>
                   Show Inactive
            </div>)}
            {!active &&(<div className="selectable btn btn-primary" onClick={()=>{oncheckViewInactive()}}>
                  Show active 
            </div>)}
          </div>
          <div className="col-auto">
            <h4 className="title">
              <Link to={`/staff/new`} className="btn btn-primary btn-fill">
                Add Staff <FontAwesomeIcon icon={faPlus} />
              </Link>
            </h4>
          </div>
        </div>
        <br />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <StaffList staffs={staffs || []}>
              {({ staff }) => (
                <div className="row justify-content-md-end">
                  <div className="col-auto text-right">
                    <Checkbox
                      label="Active"
                      inline
                      checked={staff.active}
                      onChange={onCheckNotify({
                        type: "active",
                        staff
                      })}
                      number={`active-${staff.id}`}
                    />
                  </div>
                  <div className="col-auto text-right">
                    <Checkbox
                      label="Notify By SMS"
                      inline
                      checked={staff.notify_by_sms}
                      onChange={onCheckNotify({ type: "notify_by_sms", staff })}
                      number={`notify-sms-${staff.id}`}
                    />
                  </div>
                  <div className="col-auto text-right">
                    <Checkbox
                      label="Notify By Email"
                      inline
                      checked={staff.receiver_mailer}
                      onChange={onCheckNotify({
                        type: "receiver_mailer",
                        staff
                      })}
                      number={`notify-email-${staff.id}`}
                    />
                  </div>
                  <div className="col-auto text-right">
                    <Link to={`${match.url}/${staff.id}/edit`}>
                      Edit <FontAwesomeIcon icon={faEdit} />
                    </Link>
                  </div>
                </div>
              )}
            </StaffList>
          </Col>
        </Row>
      </div>
    </div>
  );
});

Staffs.propTypes = propTypes;

export default WithFetchStaffs(Staffs);
